import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Create a single Pinia instance for all app instances
const pinia = createPinia()

/**
 * Creates a Vue instance for each element matching the selector.
 * @param {string} selector - CSS selector
 * @param {Object} options - Vue instance options
 * @param {function} setup - Optional setup function to execute on Vue instance
 */
function createVueInstance(selector, options, setup) {
  const elements = Array.from(document.querySelectorAll(selector))
  elements.forEach(element => {
    const app = createApp(options)
    app.config.globalProperties.window = window
    app.use(pinia)

    if (setup) {
      setup(app)
    }

    app.mount(element)
  });
}

// Create and intialize app on each vue instance element

import PhysiciansSearchInput from './components/PhysiciansSearchInput.vue'
import PhysiciansLastNameFilter from './components/PhysiciansLastNameFilter.vue'
import PhysiciansFilters from './components/PhysiciansFilters.vue'
import PhysiciansResults from './components/PhysiciansResults.vue'
import Pagination from './components/Pagination.vue'
import SearchResults from './components/SearchResults.vue'
import AnimateNumber from './components/AnimateNumber.vue'
import PieChart from './components/PieChart.vue'

createVueInstance(
  '#physiciansSearchInput',
  {
    components: {
      PhysiciansSearchInput
    }
  }
)

createVueInstance(
  '#physiciansLastNameFilter',
  {
    components: {
      PhysiciansLastNameFilter
    }
  }
)

createVueInstance(
  '#physiciansFilters',
  {
    components: {
      PhysiciansFilters
    }
  }
)

createVueInstance(
  '#physiciansResults',
  {
    components: {
      PhysiciansResults
    }
  }
)

createVueInstance(
  '#physiciansPagination',
  {
    components: {
      Pagination
    }
  }
)

createVueInstance(
  '#searchResults',
  {
    components: {
      SearchResults
    }
  }
)

createVueInstance(
  '#statNumber',
  {
    components: {
      AnimateNumber
    }
  }
)

// Pie Chart integration, unused for now
createVueInstance(
  '.piechart-component',
  {
    components: {
      PieChart
    }
  }
)
